const translations = {
    validCompanyName: 'Please enter a valid company name'
};

export default translations;
